import React from 'react';

/**
 * Bag / accessories icon used by the Tilbehør Level 1 row.
 * Sized by CSS; fill inherits via the global currentColor rule.
 */
const IconBag = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    role="presentation"
    aria-hidden="true"
    {...props}
  >
    <path d="M14.03 1.97H1.97c-1 0-1.81.81-1.81 1.808v8.444c0 .999.81 1.809 1.81 1.809h12.06c1 0 1.81-.81 1.81-1.81V3.779c0-.999-.81-1.809-1.81-1.809ZM1.367 5.587h13.268v1.206h-4.222a.603.603 0 0 0-.603.603c0 1.393-1.507 2.263-2.714 1.567a1.81 1.81 0 0 1-.904-1.567.603.603 0 0 0-.603-.603H1.366Zm.603-2.413h12.062c.333 0 .603.27.603.603v.604H1.366v-.604c0-.333.27-.603.603-.603Zm12.062 9.65H1.969a.603.603 0 0 1-.603-.603V8h3.679c.462 2.275 3.213 3.197 4.952 1.66A3.015 3.015 0 0 0 10.955 8h3.679v4.222c0 .333-.27.603-.603.603Z" />
  </svg>
);

export default IconBag;
